import { render, staticRenderFns } from "./Informinfo.vue?vue&type=template&id=72c1aee0"
import script from "./Informinfo.vue?vue&type=script&lang=js"
export * from "./Informinfo.vue?vue&type=script&lang=js"
import style0 from "./Informinfo.vue?vue&type=style&index=0&id=72c1aee0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports